import { GetTripInput, TripOutput } from '@allocab/allocab-passenger-shared-types';
import { useIsMutating, useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';

import { mutationKeys } from '../services/datastore/mutationKeys';
import { queryKeys } from '../services/datastore/queryKeys';
import { silentQueryErrorHandler } from '../services/datastore/react-query';
import { passengerApi } from '../services/network/Api';

export const fetchTrip = (input: GetTripInput) => passengerApi.get<GetTripInput, TripOutput>('/trip/v1/trip', input);

export const useFetchTrip = (
  key: string,
  options: Omit<UseQueryOptions<TripOutput, unknown, TripOutput, string[]>, 'queryKey' | 'queryFn'> = {},
) => {
  const isCancelling = useIsMutating(mutationKeys.user.askCancellation(key));
  const isConfirmingCancellation = useIsMutating(mutationKeys.user.confirmCancellation(key));
  const isNoting = useIsMutating(mutationKeys.user.createNote(key));
  const isUpdating = useIsMutating(mutationKeys.user.updateTrip(key));
  const isConfirmingUpdate = useIsMutating(mutationKeys.confirmUpdateTrip(key));
  const isUpdatingTransportNumber = useIsMutating(mutationKeys.user.updateTripTransportNumber(key));
  const tripQuery = useQuery(queryKeys.user.fetchTrip(key), () => fetchTrip({ key }), {
    ...options,
    enabled:
      !(options.enabled === false) &&
      !isCancelling &&
      !isNoting &&
      !isUpdating &&
      !isUpdatingTransportNumber &&
      !isConfirmingCancellation &&
      !isConfirmingUpdate,
    onError: silentQueryErrorHandler,
  });

  return tripQuery;
};
